
import React, { useContext, useEffect, useState } from 'react';

import { Button, Card, Col, Dropdown, Form, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';

import Flex from 'components/common/Flex';
import { useNavigate } from 'react-router-dom';
import { fileUpload } from 'functions/fileUpload';
import FalconDropzone from 'components/common/FalconDropzone';
import Avatar from 'components/common/Avatar';
import { isIterableArray } from 'helpers/utils';
import avatarImg from 'assets/img/team/avatar.png';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { AuthWizardContext } from 'context/Context';
import { useForm } from 'react-hook-form';
import { toastMessageBox } from 'components/ToastifyMessage';

const ProfileImageUpload=({setAttachmentHandler,imgSrc})=>{
  const API = process.env.REACT_APP_API_PATH;
  const { user } = useContext(AuthWizardContext);
  const { register, handleSubmit, setValue } = useForm();

  const [profileImageRead,setProfileImageRead]=useState(null);



    const [attachments, setAttachments] = useState([
        // { id: 1, name: 'winter.jpg', size: 893952, type: 'image/jpg',fileNo:1,file:null },
        // { id: 2, name: 'coffee.zip', size: 350208, type: 'application/zip',fileNo:2,file:null }
      ]);

      const [isFileUploading,setIsFileUploading]=useState(false);

      const [avatar, setAvatar] = useState([
        ...(user.avater ? user.avater : []),
        { src: avatarImg }
      ]);


useEffect(() => {
  setAttachmentHandler(attachments);
}, [attachments]);

useEffect(() => {
  setProfileImageRead(imgSrc);
}, [imgSrc]);



      const uploadFile=(file)=>{
        console.log('uploadFile ',file)
      return  new Promise(async (resolve,reject)=>{
        const formData = new FormData();
        formData.append('file', file);
        const { name, size, type } = file;
       fileUpload(`${name}, ${size}, ${type}`, '5:30', 1,name, formData)
         .then(res => {
           resolve({ res, file });
         })
         .catch(err => {
           reject(err);
         });
      })
      }
    

      const handleAddAttachment =async file => {
        if (file.length === 0) return;
        console.log('files', file);
        //const file=files[0];

        setProfileImageRead(null);
        const fileArray = [];

        setIsFileUploading(true);
        const res = await uploadFile(file);
        const { name, size, type } = res.file;
        const { fileNo } = res.res.data;
        console.log('res.res.data', res.res.data);
        if (res.res.data.error) {
          toastMessageBox('Exception', `Selected file ${name} is too large`, 'warning');
          setIsFileUploading(false);
          return;
        }
        const newFile = {
          id: name + 1 + Date.now(),
          name,
          size,
          type,
          file,
          fileNo: fileNo
        };
        fileArray.push(newFile);
        setAttachments([...attachments, ...fileArray]);
        console.log('res', res);
        setIsFileUploading(false);

        console.log('fileArray', fileArray);
      };
    
    
    
      const handleDetachAttachment = id => {
        setAttachments(attachments.filter(attachment => attachment.id !== id));
      };
      
    return (
      <>
        {/* {attachments.length > 0 && (
          <div className="bg-light px-x1 py-3">
            <Flex direction="column" inline>
              {attachments.map(attachment => (
                <ComposeAttachment
                  {...attachment}
                  key={attachment.id}
                  handleDetachAttachment={handleDetachAttachment}
                />
              ))}
            </Flex>
          </div>
        )} */}

        <Flex alignItems="center" justifyContent="between">
          <Flex></Flex>

          <Flex>
            <>
            {/* {JSON.stringify(profileImageRead)} */}
              <Row className="gx-2 gy-3">    
          
                <Col md="auto">
                  {isFileUploading ? (
                    <Flex>
                      <Spinner animation="border" size="sm" />
                      <p style={{ marginLeft: '5px' }}> Please wait....</p>
                    </Flex>
                  ) : (
                    <>
                      {profileImageRead===null ? (
                        <Avatar
                          size="4xl"
                          src={
                            isIterableArray(avatar)
                              ? avatar[0]?.base64 || avatar[0]?.src
                              : ''
                          }
                        />
                      ) : (
                        <>  
                             {/* {JSON.stringify('profileImageRead')} */}
                        <Avatar size="4xl" src={`${API}/file/image/${profileImageRead}`} />
                        </>
                      )}
                    </>
                  )}
                </Col>

                <Col md>
                  <FalconDropzone
                    files={avatar}
                    onChange={(files, file) => {
                      console.log('FalconDropzone', file);
                      handleAddAttachment(file);
                      setAvatar(files);
                      setValue('avatar', files);
                    }}
                    multiple={false}
                    accept="image/*"
                    placeholder={
                      <>
                        <Flex justifyContent="center">
                          <img
                            src={cloudUpload}
                            alt=""
                            width={25}
                            className="me-2"
                          />
                          <p className="fs-0 mb-0 text-700">
                            Upload your profile picture
                          </p>
                        </Flex>
                        <p className="mb-0 w-75 mx-auto text-400">
                          Upload a 300x300 jpg image with a maximum size of
                          400KB
                        </p>
                      </>
                    }
                  />
                </Col>
              </Row>
            </>
          </Flex>
        </Flex>
      </>
    );
}

export default ProfileImageUpload;